export const MAX_IMPORT_FILE_SIZE = 10 * 1024 * 1024;

export const ACCEPTED_IMPORT_EXTENSIONS = [".csv", ".txt", ".xlsx", ".xls"];
